module.exports = __webpack_public_path__ + "static/media/EstructuraBD_EPS.6a6abfa5.xlsx";